export * from './components';
export type {
  CanCancelOrderV2Query,
  FavoriteLineItemMutation,
  OrderStatusHasEarnedLoyaltyPointsQuery,
  OrderStatusInfoQuery,
  OrderStatusPollingQuery,
  OrderStatusQuery,
} from './graphql/OrderStatus.generated';
export * from './hooks';
export * from './utils';

import {
  ChallengeCelebrationModal,
  Layout,
  OrderStatusAddress,
  OrderStatusCancellationOption,
  OrderStatusContactUs,
  OrderStatusCourierInfo,
  OrderStatusCtas,
  OrderStatusDivider,
  OrderStatusInfo,
  OrderStatusLedger,
  OrderStatusLineItemGroupHeader,
  OrderStatusLoading,
  OrderStatusLoyaltyPointsBanner,
  OrderStatusMap,
  OrderStatusPayments,
  OrderToHealthKit,
} from './components';

export const OrderStatus = {
  Layout,
  ChallengeCelebrationModal,
  Address: OrderStatusAddress,
  CancellationOption: OrderStatusCancellationOption,
  ContactUs: OrderStatusContactUs,
  CourierInfo: OrderStatusCourierInfo,
  Ctas: OrderStatusCtas,
  Divider: OrderStatusDivider,
  Info: OrderStatusInfo,
  Ledger: OrderStatusLedger,
  LineItemGroupHeader: OrderStatusLineItemGroupHeader,
  Loading: OrderStatusLoading,
  LoyaltyPointsBanner: OrderStatusLoyaltyPointsBanner,
  Map: OrderStatusMap,
  Payments: OrderStatusPayments,
  OrderToHealthKit,
};
